<template>
  <div class="row mb-4">
    <div class="col-md-4 col-sm-12 mb-3">
      <CardNumber title="Eventos Creados" :value="totalEvents" color="primary" />
    </div>
    <div class="col-md-4 col-sm-12 mb-3">
      <CardNumber title="Eventos Activos" :value="activeEvents" color="success" />
    </div>
    <div class="col-md-4 col-sm-12 mb-3">
      <CardNumber title="Eventos Concluidos" :value="finishedEvents" color="secondary" />
    </div>
  </div>
</template>

<script setup>
import CardNumber from '../components/cardNumber.vue';
import { computed } from 'vue';

const props = defineProps({
  events: {
    type: Array,
    required: true
  }
});

const totalEvents = computed(() => Array.isArray(props.events) ? props.events.length : 0);
const activeEvents = computed(() => Array.isArray(props.events) ? props.events.filter(e => e.state === 2 && e.inbox === 3).length : 0);
const finishedEvents = computed(() => Array.isArray(props.events) ? props.events.filter(e => e.state === 3).length : 0);
</script>
